import type { SagaIterator } from 'redux-saga';
import { all, fork, call, getContext, takeEvery } from 'redux-saga/effects';
import type { Client } from '@peloton/api/utils';
import { CLIENT_CONTEXT } from '@peloton/api/utils';
import { toWorkoutHistoryPath } from '@engage/overview/urls';
import type { DeleteWorkoutAction } from '@engage/workouts/redux';
import { WorkoutActionType } from '@engage/workouts/redux';
import {
  workoutsSaga as sharedWorkoutSaga,
  deleteWorkoutSaga as sharedDeleteWorkoutSaga,
} from '@engage/workouts/sagas';

const ANALYTICS_SOURCE = 'Workout Details';

export const deleteWorkoutSaga = function* (client: Client, action: DeleteWorkoutAction) {
  yield call(sharedDeleteWorkoutSaga, client, action.payload.id, ANALYTICS_SOURCE);
  yield call(action.payload.router.replace, toWorkoutHistoryPath());
};

const workoutsWatcherSaga = function* (): SagaIterator {
  const client = yield getContext(CLIENT_CONTEXT);
  yield takeEvery(WorkoutActionType.DeleteRequest, deleteWorkoutSaga, client);
};

export default function* () {
  yield all([fork(workoutsWatcherSaga), fork(sharedWorkoutSaga)]);
}
